import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { BaseCell, BaseText } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';

import {
  NebraskaSizes,
  NebraskaColors
} from '@warrenbrasil/nebraska-tokens-web';
import { getCurrencyTextColor } from '@/modules/common/helpers/currency';

interface Props {
  width?: string;
  borderRadius?: string;
  percentualValue: number;
  percentualFormatted: string;
  align?: string;
  enableToggleMoney?: boolean;
  shouldChangeColorBasedOnValue?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PercentualCell',
  props: {
    width: { default: '100%' },
    borderRadius: { default: NebraskaSizes.Radius.x100 },
    percentualValue: null,
    percentualFormatted: null,
    align: { default: 'left' },
    enableToggleMoney: { type: Boolean, default: false },
    shouldChangeColorBasedOnValue: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { width: string, borderRadius: string, percentualValue: number, percentualFormatted: string, align: string, enableToggleMoney: boolean, shouldChangeColorBasedOnValue: boolean };



const percentualColor = computed(() => {
  if (!props.shouldChangeColorBasedOnValue)
    return NebraskaColors.elementPrimary;
  return getCurrencyTextColor(props.percentualValue);
});

const component = computed(() => {
  return props.enableToggleMoney ? Money : 'span';
});

return { __sfc: true,props, percentualColor, component, BaseCell, BaseText }
}

})